import { ICustomer, ICustomerByClient } from "@/types/ICustomer"
import { ICustomerClient } from "@/types/ICustomerClient"
import { IDepot } from "@/types/IDepot"
import { IRole } from "@/types/IRole"


export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  login: string;
  email: string;
  phone: string;
  enabled: boolean;
  roles?: IRole[];
  customerClients: ICustomerClient[];
  customers?: ICustomer[];
  depots?: IDepot[];
}

export interface IUserSelectListItem {
  id: string;
  name: string;
}

export interface IUserCreate {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  username?: string;
  isArchived: boolean;
  roles?: IRole[];
  customersClientIds?: number[]
  customers?: ICustomer[];
  depotIds?: number[];
}

export interface IUserUpdate extends IUserCreate {
  id: string;
}

export interface IUserChangePassword {
  id: string;
  password?: string;
  isNotifyUser : boolean;
  isPasswordAutoGenerated: boolean
}

export const USERS_KEY = "USERS_KEY"

export const USER_PASSWORD_MINLENGTH = 8
export const USER_PASSWORD_REGEXP = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
